import React from "react";
import CenterManagementDashboard from "../../components/Super Admin/Center Management/CenterManagementDashboard";
import "../../css/AddStationsPage.css";

const CenterDashboardPage: React.FC = () => {
  return (
    <>
      <CenterManagementDashboard />
    </>
  );
};

export default CenterDashboardPage;
